import React from 'react';

import { Divider, Radio, RadioChangeEvent, Space } from 'antd';

interface SelectLanguageI {
   locale: string;
   lang: string;
   onChangeLocale: (value: string) => void;
   onChangeLang: (value: string) => void;
}

const SelectLanguage = ({ locale, lang, onChangeLocale, onChangeLang }: SelectLanguageI) => {
   const handleChangeLocale = (e: RadioChangeEvent) => onChangeLocale(e.target.value);

   const handleChangeLang = (e: RadioChangeEvent) => onChangeLang(e.target.value);

   return (
      <div>
         <Radio.Group onChange={handleChangeLocale} value={locale}>
            <Space direction='vertical'>
               <Radio value={'es'}>
                  <Space>
                     <span role='img' aria-label='mx'>
                        🇲🇽
                     </span>
                     {lang === 'es' ? 'México' : lang === 'en' ? 'Mexico' : 'Mexique'}
                  </Space>
               </Radio>

               <Radio value={'en'}>
                  <Space>
                     <span role='img' aria-label='eu'>
                        🇺🇸
                     </span>
                     {lang === 'es' ? 'Estados Unidos' : lang === 'en' ? 'United States' : 'États-Unis'}
                  </Space>
               </Radio>

               <Radio value={'es-ES'}>
                  <Space>
                     <span role='img' aria-label='es-ES'>
                        🇪🇸
                     </span>
                     {lang === 'es' ? 'España' : lang === 'en' ? 'Spain' : 'Espagne'}
                  </Space>
               </Radio>

               <Radio value={'co'}>
                  <Space>
                     <span role='img' aria-label='co'>
                        🇨🇴
                     </span>
                     {lang === 'es' ? 'Colombia' : lang === 'en' ? 'Colombia' : 'Colombie'}
                  </Space>
               </Radio>

               <Radio value={'pa'}>
                  <Space>
                     <span role='img' aria-label='pa'>
                        🇵🇦
                     </span>
                     {lang === 'es' ? 'Panamá' : lang === 'en' ? 'Panama' : 'Panama'}
                  </Space>
               </Radio>

               <Radio value={'pr'}>
                  <Space>
                     <span role='img' aria-label='pr'>
                        🇵🇷
                     </span>
                     {lang === 'es' ? 'Puerto Rico' : lang === 'en' ? 'Puerto Rico' : 'Porto Rico'}
                  </Space>
               </Radio>

               <Radio value={'ar'}>
                  <Space>
                     <span role='img' aria-label='ar'>
                        🇦🇷
                     </span>
                     {lang === 'es' ? 'Argentina' : lang === 'en' ? 'Argentina' : 'Argentine'}
                  </Space>
               </Radio>
               <Radio value={'cr'}>
                  <Space>
                     <span role='img' aria-label='cr'>
                        🇨🇷
                     </span>
                     {lang === 'es' ? 'Costa Rica' : lang === 'en' ? 'Costa Rica' : 'Costa Rica'}
                  </Space>
               </Radio>
               <Radio value={'pe'}>
                  <Space>
                     <span role='img' aria-label='ar'>
                        🇵🇪
                     </span>
                     {lang === 'es' ? 'Perú' : lang === 'en' ? 'Peru' : 'Pérou'}
                  </Space>
               </Radio>


               <Radio value={'fr'}>
                  <Space>
                     <span role='img' aria-label='fr'>
                        🇫🇷
                     </span>
                     {lang === 'es' ? 'Francia' : lang === 'en' ? 'France' : 'France'}
                  </Space>
               </Radio>

               {/* <Radio value={'cl'}>
                  <Space>
                     <span role='img' aria-label='cl'>
                        🇨🇱
                     </span>
                     {lang === 'es' ? 'Chile' : 'Chile'}
                  </Space>
               </Radio> */}
            </Space>
         </Radio.Group>
         <Divider />
         <Radio.Group onChange={handleChangeLang} value={lang}>
            <Space direction='vertical'>
               <Radio value={'es'}>{lang === 'es' ? 'Español' : lang === 'en' ? 'Spanish' : 'Espagnol'}</Radio>
               <Radio value={'en'}>{lang === 'es' ? 'Ingles' : lang === 'en' ? 'English' : 'Anglais'}</Radio>
               <Radio value={'fr'}>{lang === 'es' ? 'Frances' : lang === 'en' ? 'French' : 'Français'}</Radio>
               {/* <Radio value={'PT'}>Portugues</Radio> */}
            </Space>
         </Radio.Group>
      </div>
   );
};
export default SelectLanguage;
